declare var require: any;
import {Component, OnInit, ViewChild, AfterViewInit, ElementRef, Renderer, HostListener} from '@angular/core';
import {NgxCarousel} from 'ngx-carousel';
import jwt_decode from 'jwt-decode';
import {Router} from '@angular/router';
import {RightSideService} from './buyback-form/main-section/shared/right-side.service';
import {DataService} from './buyback-form/main-section/shared/data.service';
import {Category} from './buyback-form/main-section/shared/classes/category.model';
import {PageContent} from './buyback-form/main-section/shared/classes/page-content.model';
import {FormDataService} from './buyback-form/main-section/shared/form-data.service';
import {NavigationBarService} from './buyback-form/main-section/shared/navigation-bar.service';
import {storageFactory} from './app-storage';
import {environment} from '../environments/environment';

const cookie = require('cookie');

export function mapsTurkishCharToEnglishChar(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-zA-ZŞşÖöİiĞğÜüÇç ]/g, '')
    .replace('ğ', 'g')
    .replace('ü', 'u')
    .replace('ş', 's')
    .replace('ı', 'i')
    .replace('ö', 'o')
    .replace('ç', 'c')
    .split(' ')
    .join('-');
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
  imgags: string[];
  categories: Category[] = [];
  @ViewChild('ngxCarousel') ngxCarousel: any;
  hovered = false;
  isIOS: boolean;
  selectedTab = 1;
  pageContent: PageContent;
  jwt: any;
  parentCookie: any;
  parentLocation: any;
  parentBuybackTopHeight: any;
  public carouselTileTwoItems: Array<any> = [];
  public carouselTileTwo: NgxCarousel;
  public showComponent: Boolean = true;

  constructor(
    private rightSideService: RightSideService,
    private dataService: DataService,
    private formDataService: FormDataService,
    private navBarService: NavigationBarService,
    public renderer: Renderer,
    private router: Router,
  ) {
    const isMacLike = navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) ? true : false;
    const isIOS = navigator.platform.match(/(iPhone|iPod|iPad)/i) ? true : false;
    const isNotWindows = isMacLike || isIOS;
    this.rightSideService.pageContentChange.subscribe(val => {
      this.pageContent = this.rightSideService.getPageContent();
    });
    this.navBarService.selectedTabChange.subscribe(val => {
      this.selectedTab = this.navBarService.getSelectedTab();
    });
    storageFactory(localStorage).setItem('isIOS', isNotWindows.toString());
    this.isIOS = (storageFactory(localStorage).getItem('isIOS') === 'true');
  }

  @HostListener('window:message', ['$event'])
  onPostMessage(event) {
    if (!environment.production && !this.rightSideService.getShopperId()) {
      this.rightSideService.setIsAuth(true);
      this.rightSideService.setShopperId('587e7de7-9e0d-4977-a331-e1a9c01dbfd0');
      this.rightSideService.setShopperEmail('test@garcia.com.tr');
      return true;
    }
    try {
      if (event && event.data && event.data.eventName === 'cookie' && !this.parentCookie) {
        this.parentCookie = event.data.data;
        document.cookie += event.data.data;
        const cookieObj = cookie.parse(event.data.data);
        if (cookieObj.jwt) {
          const decoded = jwt_decode(cookieObj.jwt);
          this.jwt = JSON.stringify(decoded);
          if (decoded.AppKey === '8093F525-1BAC-49C0-8FB7-C9F7B2DA04CF' &&
            decoded.IsAuthenticated !== 'True') {
            this.rightSideService.setIsAuthWarning(true);
          }

          if (decoded.IsAuthenticated === 'True') {
            this.rightSideService.setIsAuth(true);
          }
          if (decoded.UserId) {
            this.rightSideService.setShopperId(decoded.UserId);
          }
          if (decoded.Email) {
            this.rightSideService.setShopperEmail(decoded.Email);
          }
        }
      }
      if (event && event.data && event.data.eventName === 'location' && !this.parentLocation) {
        this.parentLocation = event.data.data;
        window['overrideLocation'] = event.data.data;
      }

      if (event && event.data && event.data.eventName === 'buybackTopHeight' && !this.parentBuybackTopHeight) {
        this.parentBuybackTopHeight = event.data.height;
        this.rightSideService.setTopHeight(this.parentBuybackTopHeight);
      }

    } catch {
      return false;
    }
  }

  ngOnInit() {
    this.carouselTileTwo = {
      grid: {xs: 1, sm: 3, md: 4, lg: 4, all: 230},
      speed: 600,
      interval: 3000,
      point: {
        visible: false
      },
      load: 2,
      touch: true
    };

    this.carouselTileTwoLoad();

    parent.postMessage('cookie', '*');
    parent.postMessage('location', '*');
    parent.postMessage({event_id: 'topHeight'}, '*');
    const cookieInterval = setInterval(() => {
      if (!this.parentCookie) {
        parent.postMessage('cookie', '*');
      } else {
        clearInterval(cookieInterval);
      }
    }, 50);
    const locationInterval = setInterval(() => {
      if (!this.parentLocation) {
        parent.postMessage('location', '*');
      } else {
        clearInterval(locationInterval);
      }
    }, 50);
    const topHeightInterval = setInterval(() => {
      if(!this.parentBuybackTopHeight) {
        parent.postMessage({
          event_id: 'topHeight'
        }, '*');
      } else {
        clearInterval(topHeightInterval)
      }
    }, 50);


    const formData = JSON.parse(storageFactory(localStorage).getItem('formData'));
    const isRedirected = JSON.parse(storageFactory(localStorage).getItem('redirectedCategoryId'));
    if (formData && isRedirected) {
      this.rightSideService.setIsRedirected(true);
    }

    if (formData) {
      this.formDataService.setZerothTabData(formData.zeroth);
      this.formDataService.setFirstTabData(formData.first);
      this.formDataService.setSecondTab(formData.second);
      this.rightSideService.selectedProductId = formData.second.productId;
    }

    if (window.location.pathname == '/status') {
      this.showComponent = false;
    }
  }

  ngAfterViewInit() {
  }

  onmoveFn(carousel) {
    if (carousel.isLast && carousel.carouselWidth < 450) {
      this.renderer.setElementStyle
      (this.ngxCarousel['el']['nativeElement'], 'marginLeft', '30px');
    } else {
      this.renderer.setElementStyle
      (this.ngxCarousel['el']['nativeElement'], 'marginLeft', '0');
    }
  }

  getSelectedCategory(tile: Category) {
    storageFactory(localStorage).setItem('category', '' + tile.id);
    this.scrollTop();
    if (this.rightSideService.firstTab) {
      this.rightSideService.firstTab.firstForm.controls['brand'].patchValue('');
      this.rightSideService.firstTab.firstForm.controls['model'].patchValue('');
      this.rightSideService.firstTab.models = [];
      this.rightSideService.firstTab.selectedBrand = false;
      this.rightSideService.firstTab.selectedModel = false;
    }
    if (this.rightSideService.firstForm) {
      this.rightSideService.firstForm.reset();
    }
    this.navBarService.clear();
    this.formDataService.clear();
    this.rightSideService.isForwarded = false;
    this.rightSideService.setTopImageUrl(tile.topImageUrl);
    this.rightSideService.setImageUrl(tile.imageUrl);
    this.rightSideService.setPrice(0);
    this.rightSideService.setLabel('');
    this.rightSideService.setResetChanged(true);
    this.router.navigate(['/' + tile.friendlyUrl]);
    this.getPageContents(tile.id);
  }

  scrollTop() {
    parent.postMessage({
      scrollY: 110
    }, '*');
  }

  getPageContents(categoryId: number) {
    this.dataService
      .getPageContents(categoryId)
      .subscribe((res: PageContent) => {
        this.rightSideService.setPageContent(res);
      });
  }

  public carouselTileTwoLoad() {
    this.dataService.getCategories().subscribe((res: Category[]) => {
      this.categories = res;
      this.rightSideService.setTopImageUrl(this.categories[0].topImageUrl);
      this.carouselTileTwoItems = [...this.categories];
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts